module.exports = __webpack_public_path__ + "img/logo-green.43a6964a.svg";